import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { FileText } from "lucide-react";
import { formatRupiah } from "@/lib/format";

export const NotaList = ({ numbers = [], amounts = [], testid }) => {
  const [q, setQ] = useState("");
  if (numbers.length === 0) return <span className="text-slate-400">-</span>;
  const items = numbers.map((n, i) => ({ n, a: amounts[i] }));
  const hasAmt = amounts.length > 0;
  const total = amounts.reduce((s, a) => s + (a || 0), 0);
  const rest = numbers.length - 2;
  const filtered = items.filter((it) => it.n.toLowerCase().includes(q.toLowerCase()) || String(Math.round(it.a || 0)).includes(q.replace(/\D/g, "") || "~"));
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} data-testid={testid}
          className="inline-flex flex-col items-start gap-0.5 rounded-2xl border border-[#E7E7EA] bg-white px-2.5 py-1 hover:bg-zinc-50 transition-colors max-w-[260px] text-left">
          <span className="inline-flex items-center gap-1.5 max-w-full">
            <FileText className="h-3.5 w-3.5 text-slate-400 shrink-0" />
            <span className="truncate">{items.slice(0, 2).map((it) => hasAmt ? `${it.n} (${formatRupiah(it.a)})` : it.n).join(", ")}</span>
            {rest > 0 && <span className="shrink-0 rounded-full bg-zinc-100 px-1.5 text-[11px] font-semibold text-slate-600">+{rest}</span>}
          </span>
          {hasAmt && <span className="pl-5 text-[11px] font-semibold text-slate-700" data-testid={`${testid}-total`}>{numbers.length} nota · {formatRupiah(total)}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[22rem] rounded-2xl p-3" onClick={(e) => e.stopPropagation()}>
        <div className="mb-2 flex items-center justify-between text-xs">
          <span className="font-semibold text-slate-800">{numbers.length} nota</span>
          {hasAmt && <span className="font-semibold text-slate-900">{formatRupiah(total)}</span>}
        </div>
        {numbers.length > 8 && <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari nota / nominal..." className="mb-2" data-testid={`${testid}-search`} />}
        <div className="max-h-64 overflow-y-auto flex flex-col gap-1">
          {filtered.map((it, i) => (
            <div key={`${it.n}-${i}`} className="flex items-center justify-between gap-3 rounded-lg bg-zinc-50 px-2.5 py-1.5 text-xs">
              <span className="text-slate-700 truncate">{it.n}</span>
              {hasAmt && <span className="font-semibold text-slate-900 shrink-0">{formatRupiah(it.a)}</span>}
            </div>
          ))}
          {filtered.length === 0 && <div className="py-3 text-center text-xs text-slate-400">Tidak ditemukan</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
